var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.CBean
  }, [_c('div', {
    class: _vm.$style.icon
  }, [_vm._t("default", function () {
    return [_vm.icon ? _c(_setup.SIcon, {
      attrs: {
        "icon": _vm.icon,
        "size": "24"
      }
    }) : _vm._e()];
  })], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };